import type { TrackIntercomOnboardingEventRequest } from '@brand24-original/llm-types';
import { client } from '../../../services/apiClient';

const ENDPOINT = '/intercom/onboarding-events';

export const sendIntercomOnboardingEvent = async (
  request: TrackIntercomOnboardingEventRequest
): Promise<void> => {
  await client(true, true).post<void>(ENDPOINT, request);
};
